// CONTEXTS
import { CustomersProvider } from "../../contexts/customers/customers.context";
// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import CustTicketPage from "./page.custticket.page";

const CustTicketsLayout = () => {
  return (
    <LoggedIn>
      <CustomersProvider>
           <CustTicketPage />
      </CustomersProvider>
    </LoggedIn>
  );
};

export default CustTicketsLayout;
